import { memo } from "react";
import { Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Popup from "../Popup.js";
import Form from "../Form.js";

const SelectAnimalPopup = ({
    width = "700px",
    isOpen,
    onClose,
    onDecline,
    handleAnimalSelectFormSubmit,
    animals = [],
    type = "",
    selectedOwner = null,

}) => {

    const formContent = [
        {
            customType: "dropdown",
            id: "registrationCode",
            items: animals,
            placeholder: "Ζώο",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const handleAnimalDropdownSelectSubmit = (values) => {
        if (type === "OwnerAnimalSelect" && selectedOwner) {
            handleAnimalSelectFormSubmit({ animal: values.registrationCode, owner: selectedOwner });
        } else {
            handleAnimalSelectFormSubmit(values);
        }
    };
    return (
        <Popup
            width={width}
            open={isOpen}
            title={"Επιλογή Ζώου"}
            titleColor={"black"}
            onClose={onClose}
        >
            <IconButton
                aria-label="close"
                onClick={onDecline}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <Typography sx={{ color: "dark.main", marginTop: "-1rem", marginBottom: "1rem" }}>
                {"Υπάρχουν πολλαπλά ζώα με τον ίδιο 4-ψήφιο κωδικό. Επιλέξτε αυτό που σας ενδιαφέρει."}
            </Typography>
            <Form content={formContent} onSubmit={handleAnimalDropdownSelectSubmit} />
        </Popup>
    )
}

export default memo(SelectAnimalPopup);